import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { useInView } from 'react-intersection-observer';

import Curtain from './../Curtain';
import Stat from './../Stat';
import * as Utils from '../../utils';
import { BOARD_OF_TRUSTEES_ID } from './../../constants';
import ScrollButton from '../ScrollButton';

const Stats = ({ branding, items, title, ...rest }) => {
  const slides = items;
  const hasSlides = !!slides?.length;
  const sliderRef = useRef();
  const [statsRef, isStatsInView] = useInView({ threshold: 0.8 });
  const settings = {
    arrows: false,
    autoplaySpeed: 2000,
    beforeChange: (oldIndex, newIndex) => {
      if (isStatsInView && newIndex === 0) {
        Utils.scroll(BOARD_OF_TRUSTEES_ID);
      }
    },
    swipe: false,
  };

  if (!hasSlides) {
    return null;
  }

  useEffect(() => {
    if (isStatsInView) {
      sliderRef.current.slickPlay();
    } else {
      sliderRef.current.slickPause();
    }
  }, [isStatsInView]);

  return (
    <div className='stats' ref={statsRef} {...rest}>
      {title && <Curtain branding={branding} title={title} />}
      <Slider ref={sliderRef} {...settings}>
        {slides.map((item, index) => {
          return <Stat {...item} key={index} />;
        })}
      </Slider>

      <div className='stats__cta'>
        <ScrollButton href={`#${BOARD_OF_TRUSTEES_ID}`} />
      </div>
    </div>
  );
};

Stats.propTypes = {
  branding: PropTypes.bool,
  items: PropTypes.array,
  title: PropTypes.string,
};

export default Stats;
